import { render, staticRenderFns } from "./ServicesLayout.vue?vue&type=template&id=77475066&scoped=true"
import script from "./ServicesLayout.vue?vue&type=script&lang=js"
export * from "./ServicesLayout.vue?vue&type=script&lang=js"
import style0 from "./ServicesLayout.vue?vue&type=style&index=0&id=77475066&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77475066",
  null
  
)

export default component.exports